import React from 'react';
import ExplanationButton from '../ExplanationButton';
import '../../../css/common/WorkAvailability.css';

export const WORK_AVAILABILITY_HELP = {
  responseStatus: {
    title: 'ステータスの設定',
    body: 'チャットに表示する今日の対応状況です。始業・終業の時刻は変わりません。\n「勤務予定に合わせる」は、自動切替がオンの場合に登録した予定に連動します。それ以外は今日だけ勤務予定より優先されます。\nリセットすると今日の手動ステータスとひとことを解除します。勤務予定は変更しません。オンライン状況はアーティストに公開されません。',
  },
  responseSharing: {
    title: 'ひとことの公開先',
    body: 'オフのときは管理者のみ、オンのときは管理者とアーティストにひとことを表示します。ひとことを入力すると切り替えられます。\nステータス自体はチャット相手に表示されます。オンライン状況は公開されません。',
  },
  responseExpiry: {
    title: 'ステータスの有効期限',
    body: '手動で設定したステータスとひとことは、日付が変わると自動解除されます。その後は勤務予定に従います。登録済みの勤務予定は変更されません。',
  },
  overview: {
    title: '今日・明日の予定について',
    body: '今日の勤務時間と明日の予定を設定します。連休なら、休みが明ける日時も指定できます。オンライン状況はアーティストには表示されません。',
  },
  period: {
    title: '勤務時間の設定',
    body: '出勤日は今日・明日に固定され、始業と終業の時刻だけを選びます。夜勤の場合は終業日を「翌日」にできます。保存した時刻は次回の初期値になります。\n休日・連休は、休みの開始から休みが明ける日時まで指定してください。',
  },
  timeOff: {
    title: '連休の設定',
    body: '明日からのお休みを登録できます。連休の場合は、休みの開始と休みが明ける日時を指定してください。休み明けの勤務時間も任意で設定できます。',
  },
} as const;

export default function WorkAvailabilityHelp({ topic }: { topic: keyof typeof WORK_AVAILABILITY_HELP }) {
  const content = WORK_AVAILABILITY_HELP[topic];
  return (
    <ExplanationButton
      {...content}
      variant="modal"
      ariaLabel={`${content.title}の説明`}
      buttonClassName="work-availability__help-button"
    >{null}</ExplanationButton>
  );
}
